import { render, staticRenderFns } from "./shot-material-list.vue?vue&type=template&id=30037b46&scoped=true"
import script from "./shot-material-list.vue?vue&type=script&setup=true&lang=js"
export * from "./shot-material-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./shot-material-list.vue?vue&type=style&index=0&id=30037b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30037b46",
  null
  
)

export default component.exports